import { combineReducers } from 'redux';
import { gameTypes } from '../actions/_actionTypes';
import { playerTypes } from '../actions/_actionTypes';

const byId = (state = {}, action) => {
    switch (action.type) {
        case gameTypes.FETCH_GAMES: {
            const entry = {};
            for (let i = 0; i < action.payload.length; i++) {
                const item = action.payload[i];
                entry[item.id] = item;
            }
            return {
                ...entry,
            };
        }
        case gameTypes.EDIT_GAME_SUCCESS: {
            const { payload } = action;
            const { id, gameStartTime, gameEndTime, arena, cost } = payload;
            const game = state[id];

            return {
                ...state,
                [id]: {
                    ...game,
                    gameStartTime,
                    gameEndTime,
                    arena,
                    cost
                }
            }
        }
        case playerTypes.ADD_PLAYER_SUCCESS:{
            const { payload } = action
            const { gameId, isGoalie } = payload;
            const game = state[gameId];
            let goalieCount = isGoalie ? game.goalieCount + 1 : game.goalieCount;
            let playerCount = isGoalie ? game.playerCount : game.playerCount + 1;

            return {
                ...state,
                [gameId]: {
                    ...game,
                    isPlayer: true,
                    goalieCount: goalieCount,
                    playerCount: playerCount
                }
            }
        }
        case playerTypes.REMOVE_PLAYER_SUCCESS:{
            const { payload } = action
            const { gameId, isGoalie } = payload;
            const game = state[gameId];
            let goalieCount = isGoalie ? game.goalieCount - 1 : game.goalieCount;
            let playerCount = isGoalie ? game.playerCount : game.playerCount - 1;

            return {
                ...state,
                [gameId]: {
                    ...game,
                    isPlayer: false,
                    goalieCount: goalieCount,
                    playerCount: playerCount
                }
            }
        }
        case gameTypes.DELETE_GAME_SUCCESS: {
            const { payload } = action
            const { gameId } = payload;
            const { [gameId.toString()]: value, ...rest } = state;
            return rest;
        }
        default:
            return state;
    }
};

const ids = (state = [], action) => {
    switch (action.type) {
        case gameTypes.FETCH_GAMES: {
            return [...action.payload.map(o => o.id)];
        }
        case gameTypes.DELETE_GAME_SUCCESS: {
            const { payload } = action
            const { gameId } = payload;
            return state.filter((item) => item !== gameId);
        }
        default:
            return state;
    }
};

export default combineReducers({
    byId,
    ids,
});


// WEBPACK FOOTER //
// ./src/reducers/game.reducer.js